<template>
    <v-tooltip text="Removes the grace period so the next session runs a full warm-up instead of skipping prep" location="top">
        <template #activator="{ props: tp }">
            <v-btn
                v-bind="tp"
                size="small"
                variant="tonal"
                color="orange"
                prepend-icon="mdi-restart"
                :loading="loading"
                @click="$emit('click')"
            >
                Reset Grace Period
            </v-btn>
        </template>
    </v-tooltip>
</template>

<script setup lang="ts">
defineProps<{ loading?: boolean }>()
defineEmits<{ click: [] }>()
</script>
